import ciLogo from '../../resources/media/logo-data_Infrastructure_insights-2x.svg';
import React  from 'react';
import * as _ from 'lodash';
import {SUPPORT_SITE} from '../../common/constants';
import {getErrorRequestIdAsString} from '../../common/utils';
import CigHeader from '../CigHeader';
import { useServerLog } from './utils';
import classnames from 'classnames';

export function ErrorPage(props) {
    useServerLog(props);

    const requestIdTrimmed = getErrorRequestIdAsString(props);
    const showRequestId = !_.isEmpty(requestIdTrimmed);

    return (
        <div id={_.get(props, 'id', 'error-container')} data-testid="error-container" className='tw-font-normal tw-not-italic tw-flex tw-flex-col tw-h-screen tw-font-title'>
            {
                _.get(props, 'showHeader', true) && <CigHeader tenantId={props.tenantId} site={props.site} showLogout={props.showLogout} />
            }
            <main id="error-main"  className='tw-flex tw-justify-center tw-flex-1 tw-text-16px' style={{padding: '70px 20px'}} data-testid="error-main">
                <section className='tw-flex tw-flex-col tw-flex-initial50 '>
                    <a id="ci-logo-img" className='tw-pb-lg' href={window.CIG.netAppConsoleUrl + '/cloud-insights'} rel="noreferrer noopener" target="_blank">
                        <img src={ciLogo} width="400" height="64" alt={'Data Infrastructure Insights'} />
                    </a>
                    <div style={{paddingLeft: '12px'}}>
                        {
                            !_.isEmpty(props.title) && ( <p id="error-title"  className='tw-mt-6px'><strong>{props.title}</strong></p> )
                        }
                        <div id="error-msg-container" className='tw-mt-12px'>
                            {
                                !_.isNil(props.message) && (_.isFunction(props.message) ? props.message() : <p>{props.message}</p>)
                            }
                            { props.children }
                        </div>
                        {
                            (!_.isNil(props.showCIContact) && props.showCIContact === true) && (
                                <p id="ci-contact-info-msg" className='tw-mt-12px'>
                                    You can reach out to
                                    <a id="cust-sup-fb-email" className='tw-text-blue-300' href="mailto:ng-cloudinsights-customerfeedback@netapp.com"> ng-cloudinsights-customerfeedback@netapp.com </a>
                                    so that we can help you with a Data Infrastructure Insights trial tenant.
                                </p>
                            )
                        }
                        {
                            (!_.isNil(props.showReceivedInError) && props.showReceivedInError === true) && (
                                <p id="ci-receive-error-msg" className='tw-mt-6px'>
                                    If you believe you are receiving this message in error, you can reach out to
                                    <a id="cust-sup-fb-email" className='tw-text-blue-300' href="mailto:ng-cloudinsights-customerfeedback@netapp.com"> ng-cloudinsights-customerfeedback@netapp.com </a>
                                    for assistance with setting up a Data Infrastructure Insights trial tenant.
                                </p>
                            )
                        }
                        {
                            (_.isNil(props.support) || props.support === true) && (
                                <p id="support-msg" className={classnames('tw-mt-6px', {'tw-pt-18px': !props.showCIContact})}>
                                    Please contact NetApp customer support or visit the <a className='tw-text-blue-300' href={SUPPORT_SITE}>NetApp support</a> site for more information.
                                </p>
                            )
                        }
                        {
                            showRequestId && (
                                <p id="error-request-id" className="tw-mt-12px tw-italic" data-testid="error-request-id">
                                    Request ID:{' '}
                                    {requestIdTrimmed}
                                </p>
                            )
                        }
                    </div>
                </section>
            </main>
        </div>
    );
}

ErrorPage.displayName = 'ErrorPage';
export default ErrorPage;
